import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import { StyleManager } from '../components/StyleManager';

// Pilar "Estilos" — gestión de los estilos de generación (crear / editar / probar).
// Es uno de los dos pilares junto con Templates; los estilos se usan en todo el
// resto de la plataforma para generar piezas (QuickGen, Novah, baked ads).

const Page = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;
const Header = styled.div`margin-bottom: ${({ theme }) => theme.spacing.lg};`;
const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSize.xxxl};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;
const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 1.5;
  a { color: ${({ theme }) => theme.colors.primary}; font-weight: 600; }
`;

export function StylesPage() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  if (!workspaceId) return null;

  return (
    <Page>
      <Header>
        <Title>Styles</Title>
        <Subtitle>
          Styles define the look of the pieces the platform generates (AI posters,
          baked ads, QuickGen). Create one from an image or by hand, edit its
          prompts and test them. Want to transform a photo of yours with a style?
          Use <Link to={`/workspace/${workspaceId}/photo-stylize`}>Image to Image</Link>.
        </Subtitle>
      </Header>
      <StyleManager workspaceId={workspaceId} />
    </Page>
  );
}
